import { createLogger } from '@telia-ace/edge-log';
import { isValidUrl } from '@telia-ace/websdk-utilities';

import * as opentok from './opentok';
import * as onsite from './onsite';

const log = createLogger('video/provider');

const state = {
  opentok: false,
  onsite: false,
};

function forwardToVideoProvider(args, opentokFn, onsiteFn) {
  try {
    log.trace('Forward to video provider; args, state:', args, state);
    return state.onsite ? onsiteFn(args) : opentokFn(args);
  } catch (e) {
    log.error('Error when forwarding to video provider!', e, args, opentokFn, onsiteFn);
    throw new Error('Error when forwarding to video provider!');
  }
}

export async function setupVideo(args) {
  log.trace('setupVideo', args);
  state.onsite = isValidUrl(args.userUrl);
  state.opentok = !state.onsite;
  return forwardToVideoProvider(args, opentok.setupVideo, onsite.setupVideo);
}

export async function chatButtonClicked(args) {
  log.trace('chatButtonClicked', args);
  return forwardToVideoProvider(args, opentok.chatButtonClicked, onsite.chatButtonClicked);
}

export async function endVideoButtonClicked(args) {
  log.trace('endVideoButtonClicked', args);
  return forwardToVideoProvider(args, opentok.endVideoButtonClicked, onsite.endVideoButtonClicked);
}

export function reloadVideoSession(args) {
  log.trace('reloadVideoSession', args);
  return forwardToVideoProvider(args, opentok.reloadVideoSession, onsite.reloadVideoSession);
}

export function reloadVideoPublisher(args) {
  log.trace('reloadVideoPublisher', args);
  return forwardToVideoProvider(args, opentok.reloadVideoPublisher, onsite.reloadVideoPublisher);
}

export function stopVideo(args) {
  log.trace('stopVideo', args);
  return forwardToVideoProvider(args, opentok.stopVideo, onsite.stopVideo);
}

export function disconnectSession(args) {
  log.trace('disconnectSession', args);
  return forwardToVideoProvider(args, opentok.disconnectSession, onsite.disconnectSession);
}

export function suspendVideo(args) {
  log.trace('suspendVideo', args);
  return forwardToVideoProvider(args, opentok.suspendVideo, onsite.suspendVideo);
}

export function sendStopVideoToClient(args) {
  log.trace('sendStopVideoToClient', args);
  return forwardToVideoProvider(args, opentok.sendStopVideoToClient, onsite.sendStopVideoToClient);
}

export function muteSpeaker(args) {
  log.trace('muteSpeaker', args);
  return forwardToVideoProvider(args, opentok.muteSpeaker, onsite.muteSpeaker);
}

export function muteMicrophone(args) {
  log.trace('muteMicrophone', args);
  return forwardToVideoProvider(args, opentok.muteMicrophone, onsite.muteMicrophone);
}

export function muteVideo(args) {
  log.trace('muteVideo', args);
  return forwardToVideoProvider(args, opentok.muteVideo, onsite.muteVideo);
}

export function cycleVideo(args) {
  log.trace('cycleVideo', args);
  return forwardToVideoProvider(args, opentok.cycleVideo, onsite.cycleVideo);
}

export function disconnectVideoWindowController(args) {
  log.trace('disconnectVideoWindowController', args);
  return forwardToVideoProvider(
    args,
    opentok.disconnectVideoWindowController,
    onsite.disconnectVideoWindowController
  );
}

export function takeVideoWindow(args) {
  log.trace('takeVideoWindow', args);
  return forwardToVideoProvider(args, opentok.takeVideoWindow, onsite.takeVideoWindow);
}
